import React from 'react';
import { skills, stats } from '../../data/homeData';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <section id="about" className="section-card about-section">
      <div className="about-header">
        <div className="about-subtitle">FIRST YOU SHOULD KNOW</div>
        <h2 className="about-title">ABOUT ME</h2>
      </div>
      <div className="about-content">
        <div className="about-left">
          <blockquote className="about-quote">
            "Building scalable e-commerce solutions that drive business growth through thoughtful architecture and team leadership."
          </blockquote>
          <div className="about-author">— Zach Biles</div>
          <div className="about-desc">
            <p>As a Director of Development at Camping World, I lead a team of ten developers in modernizing multiple Salesforce Commerce Cloud storefronts. My passion lies in architecting scalable backend solutions and bridging the gap between legacy systems and modern platforms.</p>
            <p>With over a decade of experience in e-commerce development, I've worked with companies like Carter's and Moku Collective, focusing on SFCC implementations, team leadership, and technical innovation. I believe in establishing strong engineering standards while fostering talent growth and collaboration.</p>
          </div>
        </div>
        <div className="about-skills">
          <div className="skills-header">
            <h3>What makes a leader?</h3>
            <p>My approach to leadership is built on empowering others, fostering growth, and creating environments where teams can thrive. Here's how I balance the various aspects of effective leadership:</p>
          </div>
          {skills.map((skill, index) => (
            <div key={index} className="about-skill">
              <div className="about-skill-label">
                <span>{skill.name}</span>
                <span>{skill.percentage}%</span>
              </div>
              <div className="about-skill-bar-bg">
                <div
                  className="about-skill-bar"
                  style={{ width: `${skill.percentage}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="about-stats">
        {stats.map((stat, index) => (
          <div key={index} className="about-stat">
            <div className="about-stat-number">{stat.number}</div>
            <div className="about-stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutSection;